// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        title: "Cadastros",
        icon: "personAdd",
        router: null,
        permissions: ["master", "admin", "regular"],
        children: [
            {
                title: "Clientes",
                router: "/cadastros/cliente",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Parceiros",
                router: "/cadastros/parceiro",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Instalações",
                router: "/cadastros/manutencaoinstalacao",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Instalações de Clientes",
                router: "/cadastros/clienteinstalacao",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Bonificação",
                router: "/cadastros/bonificacao",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Parâmetros",
                router: "/cadastros/parametros",
                permissions: ["admin"],
            },
            {
                title: "Usuários",
                router: "/cadastros/usuarios",
                permissions: ["admin"],
            },
            {
                title: "Histórico de Exclusão",
                router: "/cadastros/historicoexclusao",
                permissions: ["admin"],
            },
        ],
    },
    {
        title: "Faturamento",
        icon: "autoStories",
        router: null,
        permissions: ["master", "admin", "regular"],
        children: [
            {
                title: "Faturas de Usinas",
                router: "/faturamento/faturausina",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Faturas de Instalações",
                router: "/faturamento/faturainstalacao",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Faturas de Clientes",
                router: "/faturamento/faturacliente",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Faturas de Concessionárias",
                router: "/faturamento/faturaconcessionaria",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Faturas Previstas",
                router: "/faturamento/faturaprevista",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Saldos",
                router: "/faturamento/saldos",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Histórico de Saldo",
                router: "/faturamento/historicosaldo",
                permissions: ["master", "admin", "regular"],
            },
        ],
    },
    {
        title: "Cobrança Saldo Churn",
        icon: "requestQuote",
        router: null,
        permissions: ["master", "admin", "regular"],
        children: [
            {
                title: "Cobrança de Saldo Churn",
                router: "/cobrancasaldochurn/cobrancasaldochurn",
                permissions: ["master", "admin", "regular"],
            },
        ],
    },
    {
        title: "Lançamento Manual",
        icon: "exposure",
        router: null,
        permissions: ["master", "admin", "regular"],
        children: [
            {
                title: "Lançamentos",
                router: "/lancamentomanual/lancamento",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Motivo",
                router: "/lancamentomanual/motivo",
                permissions: ["master", "admin", "regular"],
            },
        ],
    },
    {
        title: "Rebalance",
        icon: "tableChart",
        router: null,
        permissions: ["master", "admin", "regular", "oem", "comercialprevendas"],
        children: [
            {
                title: "Rebalance",
                router: "/rebalance/rebalance",
                permissions: ["master", "admin", "regular"],
            },
            {
                //OeM só tem acesso a essa tela!
                title: "Geração das Usinas",
                router: "/rebalance/geracaousinas",
                permissions: ["master", "admin", "oem"],
            },
            {
                title: "Movimentação Ucs",
                router: "/rebalance/movimentacaoUcs",
                permissions: ["master", "admin", "comercialprevendas"],
            },
            {
                title: "Motivos de Movimentação",
                router: "/rebalance/motivomovimentacao",
                permissions: ["master", "admin"],
            },
            {
                title: "Histórico de Processamento",
                router: "/rebalance/historicoProcessamento",
                permissions: ["master", "admin", "regular"],
            },
        ],
    },
    {
        title: "Usinas",
        icon: "factory",
        router: null,
        permissions: ["master", "admin", "regular"],
        children: [
            {
                title: "Concessionárias",
                router: "/usinas/concessionaria",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Usinas",
                router: "/usinas/usina",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Revisão de Cotas",
                router: "/usinas/revisaocotas",
                permissions: ["master", "admin", "regular"],
            },
            {
                title: "Revisão de Instalação",
                router: "/usinas/revisaoinstalacao",
                permissions: ["master", "admin", "regular"],
            },
        ],
    },
    {
        title: "Relatórios",
        icon: "description",
        permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
        router: null,
        children: [
            {
                title: "Gerar Relatórios",
                router: "/relatorios/gerarrelatorios",
                permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
            },
            {
                title: "Relatórios",
                router: "/relatorios/listagemrelatorios",
                permissions: ["admin", "master", "regular", "oem", "consulta", "comercialprevendas"],
            },
        ],
    },
    {
        title: "Análise Tarifária",
        icon: "analytics",
        permissions: ["admin", "master"],
        router: null,
        children: [
            {
                title: "Cálculo de Rebate",
                router: "/analisetarifaria/calculorebate",
                permissions: ["admin", "master"],
            },
            {
                title: "Parâmetros Rebate",
                router: "/analisetarifaria/parametrosrebate",
                permissions: ["admin"],
            },
        ],
    },
    {
        title: "Captura de Faturas",
        icon: "camera",
        permissions: ["admin"],
        router: null,
        children: [
            {
                title: "Cadastro dos Modelos",
                router: "/capturafatura/cadastromodelo",
                permissions: ["admin"],
            },
            {
                title: "Cadastro dos Campos",
                router: "/capturafatura/cadastrocampo",
                permissions: ["admin"],
            },
            {
                title: "Cadastro das Posições",
                router: "/capturafatura/cadastroposicao",
                permissions: ["admin"],
            },
        ],
    },
    {
        title: "Alarmes",
        icon: "notificationsActive",
        router: null,
        permissions: ["master", "admin"],
        children: [
            {
                title: "Configuração de Alarme",
                router: "/alarme/configuracaoalarme",
                permissions: ["master", "admin"],
            },
            {
                title: "Grupos de Alarmes",
                router: "/alarme/grupoalarme",
                permissions: ["master", "admin"],
            },
        ],
    },
    {
        divisor: true,
    },
];
